import React from "react";
import "./ControlButton.scss";

interface ControlButtonProps {
  direction: "up" | "down";
  onClick: () => void;
}

const ControlButton = ({ direction, onClick }: ControlButtonProps) => {
  return (
    <button className="control-button" onClick={onClick}>
      {direction === "up" ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="19"
          viewBox="0 0 30 19"
          fill="none"
          aria-label="Move Up"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.882812 11.8455L15.184 0.587891V6.97734L0.882812 18.235V11.8455ZM29.1181 11.8455L15.184 0.587891V6.97734L29.1181 18.235V11.8455Z"
            fill="white"
          />
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="19"
          viewBox="0 0 30 19"
          fill="none"
          aria-label="Move Down"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M29.1172 6.97774L14.816 18.2354L14.816 11.8459L29.1172 0.588291L29.1172 6.97774ZM0.881896 6.97774L14.816 18.2354L14.816 11.8459L0.881897 0.588289L0.881896 6.97774Z"
            fill="white"
          />
        </svg>
      )}
    </button>
  );
};

export default ControlButton;
